import { render, staticRenderFns } from "./QuizFinishScreen.vue?vue&type=template&id=0c872b06&"
import script from "./QuizFinishScreen.vue?vue&type=script&lang=ts&"
export * from "./QuizFinishScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports